<template>
  <v-sheet>
    <v-card-title>
      {{ $t("scheduleInfoTitle") }}
      <v-spacer></v-spacer>
      <v-dialog v-model="dialog" persistent max-width="500px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" icon>
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </template>
        <v-card tile>
          <v-card-title>
            <span class="headline">{{ $t("scheduleInfoEdit") }}</span>
          </v-card-title>
          <v-card-text>
            <v-text-field
              :label="$t('scheduleInfoName') + '*'"
              class="mt-4"
              name="name"
              dense
              type="text"
              required
              v-model="currentSchedule.name"
              :error-messages="scheduleNameErrors"
              @input="$v.currentSchedule.name.$touch()"
              @blur="$v.currentSchedule.name.$touch()"
            ></v-text-field>
            <v-menu
              v-model="datepicker"
              :close-on-content-click="true"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="290px"
              class="ml-5"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  :label="$t('scheduleInfoActivation')"
                  name="start_dt"
                  dense
                  type="text"
                  :value="formattedDate"
                  class="mt-4"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                :min="moment.parseZone().format('YYYY-MM-DD')"
                v-model="currentSchedule.start_dt"
                no-title
                scrollable
                :locale="$i18n.locale"
              ></v-date-picker>
            </v-menu>
            <small>* {{ $t("validation") }}</small>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click="cancelEdit()">{{
              $t("btnCancel")
            }}</v-btn>
            <v-btn
              color="green darken-1"
              :disabled="$v.$invalid"
              text
              @click="editSchedule()"
              >{{ $t("btnSave") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-if="schedule" v-model="dialogDelete" max-width="500px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-bind="attrs"
            v-on="on"
            icon
            class="ml-1"
            @click="dialogDelete = true"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
        <v-card tile>
          <v-card-title class="headline">{{
            $t("scheduleInfoRemove")
          }}</v-card-title>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="green darken-1"
              text
              @click="
                removeSchedule({ id: schedule.id, redirect: true }),
                  (dialogDelete = false)
              "
              >{{ $t("btnYes") }}</v-btn
            >
            <v-btn color="red darken-1" text @click="dialogDelete = false">{{
              $t("btnNo")
            }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card-title>
    <v-simple-table dense class="mb-2">
      <template v-slot:default>
        <tbody>
          <tr>
            <th>{{ $t("scheduleInfoName") }}</th>
            <td>{{ currentSchedule.name }}</td>
          </tr>
          <tr v-if="schedule">
            <th>{{ $t("scheduleInfoStatus") }}</th>
            <td>
              <span
                :class="
                  schedule && schedule.disabled ? 'red--text' : 'green--text'
                "
                >{{
                  schedule && schedule.disabled
                    ? $t("scheduleInfoDisabled")
                    : $t("scheduleInfoEnabled")
                }}</span
              >
              <v-btn
                class="ml-1"
                v-if="!currentSchedule.disabled"
                icon
                @click="changeScheduleStatus(schedule.id)"
              >
                <v-icon>mdi-eye-off</v-icon>
              </v-btn>
              <v-btn
                class="ml-1"
                v-else
                icon
                @click="changeScheduleStatus(schedule.id)"
              >
                <v-icon>mdi-eye</v-icon>
              </v-btn>
            </td>
          </tr>
          <tr>
            <th>{{ $t("scheduleInfoActivation") }}</th>
            <td>{{ formattedDate }}</td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <breaks-table
      :breaks="currentSchedule.breaks"
      :includeDate="true"
      @onChange="updateScheduleInfo(currentSchedule)"
    ></breaks-table>
  </v-sheet>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import BreaksTable from "@/components/BreaksTable.vue";

export default {
  name: "ScheduleInfo",

  mixins: [validationMixin],

  props: ["currentSchedule"],

  data() {
    return {
      dialog: false,
      dialogDelete: false,
      datepicker: false,
    };
  },

  validations: {
    currentSchedule: {
      name: {
        required,
      },
    },
  },

  components: {
    BreaksTable,
  },

  computed: {
    ...mapGetters(["schedule", "locationId"]),
    formattedDate() {
      return this.currentSchedule.start_dt
        ? this.moment(this.currentSchedule.start_dt).format("DD.MM.YYYY")
        : "";
    },
    scheduleNameErrors() {
      const errors = [];
      if (!this.$v.currentSchedule.name.$dirty) return errors;
      !this.$v.currentSchedule.name.required &&
        errors.push(this.$i18n.t("validationScheduleName"));
      return errors;
    },
  },

  methods: {
    ...mapActions([
      "updateScheduleInfo",
      "removeSchedule",
      "changeScheduleStatus",
      "loadSchedule",
      "createSchedule",
    ]),
    editSchedule() {
      if (this.schedule) {
        this.updateScheduleInfo(this.currentSchedule);
        this.dialog = false;
      } else {
        this.createSchedule(this.currentSchedule);
        this.dialog = false;
      }
    },
    cancelEdit() {
      if (this.schedule) {
        this.dialog = false;
        this.loadSchedule(this.currentSchedule.id);
      } else {
        this.dialog = false;
      }
    },
  },
};
</script>
